
import { defineComponent } from "vue";
import AppSlide from "./app-slide.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/apps/bty-seo-pc/stores/app";

export default defineComponent({
  props: {
    btyUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    style() {
      const { scrollTop } = this;
      const start = 2372;
      const min = 0.92;
      let opacity = 0.5;
      if (scrollTop < start) {
        return { transform: `scale(${min})`, opacity };
      }
      const top = scrollTop - start;
      const delta = 0.00025;
      const scale = Math.min(top * delta + min, 1);
      const opacityDelta = top * 0.001;
      const o = Math.min(opacity + opacityDelta, 1);
      return {
        transform: `scale(${scale})`,
        opacity: o,
      };
    },
    textStyle() {
      const { scrollTop } = this;
      const start = 3050;
      if (scrollTop < start) {
        return { transform: "translateY(0px)" };
      }
      const top = scrollTop - start;
      const delta = 0.5;
      const y = Math.min(top * delta, 160);
      return { transform: `translateY(${y}px)` };
    },
    ...mapState(useAppStore, ["scrollTop"]),
  },
  render() {
    return (
      <AppSlide>
        <div class="slide4__box container" style={this.style}>
          <video controls>
            <source src={require("./bty-time-square.mp4")} type="video/mp4" />
          </video>
          <div class="slide4__text-content" style={this.textStyle}>
            <img
              class="slide4__logo"
              src={require("./slide-logo.png")}
              alt="B SPORTS"
              loading="lazy"
            />
            <h2>博出彩 必体育</h2>
            <h3>B体育首现纽约时代广场</h3>
            <p class="desc">
              For the first time, the brand's advertisement was placed in Times
              Square, New York, which was a milestone.
            </p>
            <a class="btn btn-primary" href={this.btyUrl} target="_blank">
              立即体验
              <img src={require("./arrow-right.svg")} alt="" />
            </a>
          </div>
        </div>
      </AppSlide>
    );
  },
});
